export class StandardDTO{
    id!: number;
    name?: string;
    publishingCountry?: string;
    title?: string;
    performanceCriteria: any[] = [];
}